import { CssBaseline, ThemeProvider } from '@mui/material'
import MobileWarningDialog from '@component/MobileWarningDialog'
import Router from './Router'
import theme from './theme'

function App () {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MobileWarningDialog />
      <Router />
    </ThemeProvider>
  )
}

export default App
